class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    this.loadSource();
    this.playPause = this.querySelector('[video-play-pause]');
    this.video && this.video.addEventListener('play', this.updatePlayPauseState.bind(this));
    this.video && this.video.addEventListener('pause', this.updatePlayPauseState.bind(this));
    this.mobileSrc = this.getAttribute('mobile-src');
    this.attachClickHandler();
  }

  playVideo() {
    if (this.video) {
      this.video.play();
      this.updatePlayPauseState();
    }
  }

  pauseVideo() {
    if (this.video) {
      this.video.pause();
      this.updatePlayPauseState();
    }
  }

  updatePlayPauseState() {
    if (this.playPause) {
      if (this.video.paused || this.video.ended) {
        this.playPause.setAttribute('data-state', 'play');
        this.playPause.setAttribute('aria-pressed', 'true');
      } else {
        this.playPause.setAttribute('data-state', 'pause');
        this.playPause.setAttribute('aria-pressed', 'false');
      }
    }
  }

  attachClickHandler() {
    this.addEventListener('click', (event) => {
      const target = event.target;
      if (target.hasAttribute('video-play-pause')) {
        this.toggleVideoState();
      }
    });
  }

  toggleVideoState() {
    if (this.video) {
      this.video.paused ? this.playVideo() : this.pauseVideo();
    }
  }

  loadSource() {
    const templateVideoDesktop = this.querySelector('[video-desktop]');
    const templateVideoMobile = this.querySelector('[video-mobile]');
    if (templateVideoDesktop && templateVideoMobile) {
      const videoToLoad = window.matchMedia('(min-width: 990px)').matches ? templateVideoDesktop.content.cloneNode(true) : templateVideoMobile.content.cloneNode(true);
      this.appendChild(videoToLoad);
      this.video = this.querySelector('video');
    }
  }
}

customElements.define('custom-video', CustomVideo);
